// S-028: Centraliserad normalisering av OpenAI-kompatibla chat-endpoints.
//
// `useAdminAIChat` och `AiAssistantDialog` byggde båda upp chat-completions-
// URL:er manuellt med subtila skillnader:
// - `useAdminAIChat`: ingen trailing-slash-strip → `https://x.com/` blir
//   `https://x.com//v1/chat/completions` (double-slash → 404 mot strikta
//   OpenAI-kompatibla servers).
// - `AiAssistantDialog`: strippade `/+$` korrekt.
//
// Drift mellan call-sites + en konkret bug i admin-pathen. Denna helper är
// single source of truth.

/**
 * Normalisera en användar-konfigurerad endpoint till en fullständig
 * `/v1/chat/completions`- eller `/api/chat`-URL.
 *
 * - Trailing slashes strippas (`https://x.com/` → `https://x.com`).
 * - Om endpoint redan slutar på `/v1/chat/completions` eller `/api/chat`
 *   används den direkt (post-strip).
 * - Annars appendas `/v1/chat/completions` (OpenAI-kompatibel default).
 *
 * Returnerar `null` för tomma/whitespace-only inputs så callern kan
 * surface:a "endpoint saknas"-error utan att skicka en trasig URL.
 */
export function normalizeChatEndpoint(rawEndpoint: string | undefined | null): string | null {
  if (!rawEndpoint) return null;
  const trimmed = rawEndpoint.trim();
  if (trimmed.length === 0) return null;

  const stripped = trimmed.replace(/\/+$/, '');
  if (stripped.length === 0) return null;

  if (
    stripped.endsWith('/v1/chat/completions') ||
    stripped.endsWith('/api/chat')
  ) {
    return stripped;
  }
  return `${stripped}/v1/chat/completions`;
}

/**
 * Validera att en API-key inte är tom/whitespace innan den skickas i
 * Authorization-headern. Skydd mot `Bearer ` (tom token, 7 tecken).
 */
export function isValidApiKey(rawKey: string | undefined | null): boolean {
  if (!rawKey) return false;
  return rawKey.trim().length > 0;
}
